export const Category_Url = `/c`
export const Product_Url = `/p`
export const SubCategories_Url = 'c'
export const product_prefix = 'p'
